import {Component} from 'react';
import Button from 'react-bootstrap/Button';
import NumberedListCard from '../game-views/numbered_list_card';
import "./css-files/moneyBuilder.css";
import ConductorDashboardDataCard from './conductor_dashboard_data_card';

class ConductorDashboardInfoCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
           rerender: false,
        };
        this.displayInfo = true;
        this.initialization();
    }

    initialization(){
        if (this.props.textInfo.summaryArr.length > 0){
            this.displayInfo = false;
        }
    }
    
    toggleInfoDisplay(){
        this.displayInfo = !this.displayInfo;
        this.setState({rerender: !this.state.rerender});
    }
     
    render() {
        const defaultImgSrc = "./assets/UnlockedFeatures/" + this.props.textInfo.imageURL;
        this.displayDataCard = false;
        if (this.props.textInfo.summaryArr.length > 0){
            this.summaryDisplay = this.props.textInfo.summaryArr.map((portfolioItem, index) =>
                <ConductorDashboardDataCard key={index} portfolioInfo={portfolioItem}
                    displayPercent={true}
                    summaryLevel={"subType"}
                />
            );
        }
        const listLines = this.props.textInfo.itemList.map((textLine, index) =>
            <NumberedListCard key={index} text={textLine}
               displayPercent={true}
                />
            );
    return <>
        <div className="card my-2 drop-shadow">
           <div className="card-header text-left">
                <span className="container m-0 p-0">
                    <div className="row">
                        <div className="col-sm-2"></div>
                        <div className="text-center col-sm-10">    
                            <h5>{this.props.textInfo.headerText}</h5> 
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-2">
                            <img src={defaultImgSrc} className="card_size_thumbnail_img" alt="logo" />
                        </div>
                        <div className="col-sm-10">
                              {this.displayInfo ?
                                <>
                                    <div>{this.props.textInfo.paragraph1}</div>
                                    <div className="mt-2">{this.props.textInfo.itemListText}</div>
                                    <ul className="mt-2 bulleted-list">{listLines}</ul>
                                    <div className="mt-2">{this.props.textInfo.paragraph2}&nbsp;&nbsp;
                                        <Button
                                            className="btn position-absolute"
                                            variant="outline-info"
                                            size="sm"
                                            onClick={() => this.toggleInfoDisplay()} >
                                                Collapse
                                        </Button>
                                    </div>
                                </>
                            :
                                <div>{this.props.textInfo.paragraph1}&nbsp;&nbsp;
                                        <Button  className="ml-2" variant="outline-info"  size="sm"
                                            onClick={() => this.toggleInfoDisplay()}>
                                            Learn More
                                        </Button>
                                </div>
                            }
                        </div>
                    </div>
                    {this.displayDataCard   ?
                        <div className="table-responsive">
                            <table className="table text-center align-middle
                                table-hover mt-4 table-no-space">
                                <thead>
                                    <tr>
                                        <th className="text-center table-header-middle">Account Sub-Type</th>
                                        <th className="text-center table-header-middle">
                                            <span>Out-of-Pocket</span>
                                            <br />
                                            <span>Amount</span>
                                        </th>
                                        <th className="text-right table-header-middle">Current Value</th>
                                        <th className="text-right table-header-middle">Net Change</th>
                                        <th className="text-right">Rate of <br/> Return</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.summaryDisplay}
                                </tbody>
                            </table>
                        </div>
                    :
                        null
                    }
                    <div className="text-center font-weight-bold mt-4">Click the {this.props.textInfo.buttonText} 
                       &nbsp;button to the right to create or change account.</div>
                </span>
            </div>
        </div>
    </>
    }

}

export default ConductorDashboardInfoCard;